export default __webpack_public_path__ + "static/media/showandHide.ceeb9bfb.svg";